import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss'],
})
export class DateComponent implements OnChanges {
  @Input() text = '';

  dt: Date | null = null;
  ngOnChanges(changes: SimpleChanges): void {
    this.dt = new Date(this.text);
    if (this.dt.getTime() < 0 || Number.isNaN(this.dt.getTime())) {
      this.dt = null;
    }
  }
}
